const widget  = document.getElementById('chat-widget');
const trigger = document.getElementById('chat-widget-trigger');
const panel   = document.getElementById('chat-widget-panel');
const close   = document.getElementById('chat-widget-close');

if (widget && trigger && panel) {
  function open() {
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    trigger.setAttribute('aria-expanded', 'true');
    trigger.style.display = 'none';
  }

  function closePanel() {
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.style.display = '';
  }

  trigger.addEventListener('click', open);
  if (close) close.addEventListener('click', closePanel);
}
